import React from 'react';
import classNames from 'classnames';

import { useAppSelector } from '@/store';
import { selectNShowcase } from '@/store/slices/userPreferences';
import { NEWTON_MARK_SRC } from '@/utils/nShowcase';

import './styles.scss';

export interface PageLoaderProps {
  /**
   * Background color that overrides the default color
   */
  backgroundColor?: string;
  /**
   * Whether the background should be translucid (85% opacity). If false, opacity is 1.
   * @default false
   */
  translucid?: boolean;
  /**
   * Whether the loader should cover the whole screen (fixed) or absolute to parent
   * @default true
   */
  fullscreen?: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({
  backgroundColor,
  translucid = false,
  fullscreen = true,
}) => {
  // The Newton showcase (owner pref or local switch, utils/nShowcase) swaps the
  // Whitelabels.com loader for the Newton N; index.html's boot loader does the same.
  const newtonShowcase = useAppSelector(selectNShowcase);
  return (
    <div
      className={classNames('fp-loader', {
        'fp-loader--fullscreen': fullscreen,
        'fp-loader--absolute': !fullscreen,
        'fp-loader--translucid': translucid,
      })}
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className={'fp-spinner'}>
        {newtonShowcase ? (
          <img className={'fp-newton'} src={NEWTON_MARK_SRC} alt={'Loading...'}/>
        ) : (
          <img src={'https://micros-t.b-cdn.net/whitelabels.com-loader-1775466124392.svg'} alt={'Loading...'}/>
        )}
      </div>
    </div>
  );
};

export default PageLoader;
